<app-preloader />
<a class="skip" href="#collections">Skip to content</a>
<app-header />
<main>
  <app-hero />
  <app-collections />
  <app-cinema />
  <app-ar />
  <app-products />
  <app-videos />
  <app-testimonials />
  <app-story />
  <app-mobile-app />
  <app-franchise />
</main>
<app-footer />

<app-fabs />
<app-enquiry-popup />
<app-finder />
<app-auth-popup />
